import { createContext, useContext, useState } from 'react';
import { Outlet } from 'react-router-dom';

export const MobileP360Context = createContext(null);
export const useMobileP360 = () => useContext(MobileP360Context);

export default function MobileProperty360Layout() {
  const [rangeType, setRangeType]     = useState('current_year');
  const [customStart, setCustomStart] = useState('');
  const [customEnd, setCustomEnd]     = useState('');

  const setRange = (type, start = '', end = '') => {
    setRangeType(type);
    setCustomStart(start);
    setCustomEnd(end);
  };

  return (
    <MobileP360Context.Provider value={{ rangeType, customStart, customEnd, setRange }}>
      <Outlet />
    </MobileP360Context.Provider>
  );
}
